<template lang="pug">
    div(
        class="or-navbar-item group"
        @touchstart="showMenu"
        @mouseenter="showMenu"
        @mouseleave="hideMenu"
    )
        component(
            v-bind="linkComponent"
            class="or-navbar-link text-sm text-white font-bold flex items-center h-full cursor-pointer whitespace-nowrap hover:no-underline group-hover:bg-black group-hover:text-white xl:text-base"
            style="height: 52px;"
        ) {{ data.text }}

        transition(name="fade")
            div(
                v-if="isActive"
                class="absolute z-30 top-full"
                :class="menuParentCss"
            )
                component(v-bind="menuComponent")
</template>

<script>
import { linkBuilders } from '@/helpers/mixins'
import NavBarLink from './navbarLink'
const heroTextLinkList = () =>
    import(/* webpackChunkName: "navbar-heroTextLinkList" */ './menus/heroTextLinkList')
const imageLinkList = () =>
    import(/* webpackChunkName: "navbar-imageLinkList" */ './menus/imageLinkList')
const productList = () => import(/* webpackChunkName: "navbar-productList" */ './menus/productList')
const simpleTreeLinkList = () =>
    import(/* webpackChunkName: "navbar-simpleTreeLinkList" */ './menus/simpleTreeLinkList')
const textLinkList = () =>
    import(/* webpackChunkName: "navbar-textLinkList" */ './menus/textLinkList')
const treeLinkList = () =>
    import(/* webpackChunkName: "navbar-treeLinkList" */ './menus/treeLinkList')
const flatTreeLinkList = () =>
    import(/* webpackChunkName: "navbar-flatTreeLinkList" */ './menus/flatTreeLinkList')

export default {
    components: {
        NavBarLink,
        heroTextLinkList,
        imageLinkList,
        productList,
        simpleTreeLinkList,
        textLinkList,
        treeLinkList,
        flatTreeLinkList,
    },
    mixins: [linkBuilders],
    props: {
        data: {
            type: Object,
            required: true,
        },
        isActive: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        linkComponent() {
            const item = {
                is: 'div',
                class: [
                    {
                        'relative triangle triangle-down pl-3 pr-10': this.hasMenu,
                        'px-3': !this.hasMenu,
                        'or-navbar-item-highlight text-action-dark group-hover:text-action-light':
                            this.data.isHighlighted,
                    },
                ],
            }

            if (this.data.className) item.class.push(this.data.className)

            if (this.data.urlData) {
                item.is = 'NavBarLink'
                item.urlData = this.data.urlData
                item.hasMenu = this.hasMenu
            }

            return item
        },
        menuComponent() {
            const item = {
                is: this.data.type,
                data: this.data,
                class: {
                    container: this.data.hasMenuBackground && this.data.isContentWidth,
                },
            }

            if (item.is === 'treeLinkList' && this.data.isSimple) item.is = 'simpleTreeLinkList'

            return item
        },
        hasMenu() {
            return this.data.type !== 'textLink'
        },
        menuParentCss() {
            if (this.data.hasMenuBackground) return 'bg-gray-lighter left-0 right-0 shadow-lg'
            else if (this.data.isContentWidth) {
                // isContentWidth but not hasMenuBackground so we need container set at this level
                return 'container left-0 right-0'
            }

            return null
        },
    },
    methods: {
        showMenu() {
            if (!this.hasMenu) return
            this.$emit('showMenu')
        },
        hideMenu() {
            if (!this.hasMenu) return
            this.$emit('hideMenu')
        },
    },
}
</script>
